import { getReturnWidgetBaseUrl } from "./return-widget-client";
import { SESSION_TOKEN_KEY } from "./use-session-token";

export type VariantPricingItem = {
  variantId: string;
  /** Price in cents (presentment currency). Matches CartItem.price. */
  price: number;
};

/**
 * Fetch current catalogue prices for a list of variant IDs.
 * Used by the widget (BBS-193) to refresh stale sessionStorage prices after
 * the customer finishes shopping, so display matches the Stripe charge.
 *
 * Variants absent from the catalogue are omitted — callers should fall back
 * to the existing CartItem.price for those.
 */
export async function publicGetVariantPricing(
  shopId: string,
  variantIds: string[],
): Promise<VariantPricingItem[]> {
  if (!variantIds.length) return [];

  const token = localStorage.getItem(SESSION_TOKEN_KEY) ?? "";
  const response = await fetch(
    `${getReturnWidgetBaseUrl()}public/return-request/checkout/variant-pricing`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ shopId, variantIds }),
      // 3 s timeout — on slow networks the silent catch in refreshPrices
      // falls back to /cart.js prices rather than blocking the UI indefinitely.
      signal: AbortSignal.timeout(3000),
    },
  );

  if (!response.ok) {
    throw new Error(`variant-pricing ${response.status}`);
  }

  return response.json() as Promise<VariantPricingItem[]>;
}
